import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { SocketProvider } from './SocketContext';
import ChatComponent from './ChatComponent';

const ConversationBlock = React.memo(({ sessionData, currentBlockIndex, chatMessages, onMessagesChange, conversationEnded, onStart, onCrewFinished, onNextBlock }) => {
    const [crewError] = useState(null);
    const hasStartedRef = useRef(false);

    const handleEnded = (reason) => {
        console.log('Conversation ended:', reason);
        onCrewFinished && onCrewFinished(reason);
    };
    // Trigger startCrew once on mount (or when block changes)
    useEffect(() => {
        if (!hasStartedRef.current) {
            hasStartedRef.current = true;
            onStart && onStart();
        }
    }, [currentBlockIndex, onStart]);

    return (
        <Box>
            <SocketProvider userID={sessionData.userID} roomID={sessionData.roomID} blockNo={currentBlockIndex}>
                <ChatComponent
                    chatMessages={chatMessages}
                    onMessagesChange={onMessagesChange}
                    conversationEnded={handleEnded}
                />
            </SocketProvider>
            {crewError && <Typography color="error" align="center">{crewError}</Typography>}
            {conversationEnded && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button variant="contained" onClick={onNextBlock}>Next Block</Button>
                </Box>
            )}
        </Box>
    );
});

export default ConversationBlock;
